module.exports = __webpack_public_path__ + "img/f4.8f1255a7.jpg";